import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import loadable from '@loadable/component';
import ConfigContext from '../../../contexts/ConfigContext';
import { useAddLocationSubscriberMutation } from '../../../redux/slices/locationSlice';

import LocationSubscribeForm from './LocationSubscribeForm';

import sidebarStyles from '../../../../stylesheets/public/layouts/SidebarLayout.module.postcss';
import styles from './Location.module.postcss';

const LocationMap = loadable(() => import('./LocationMap'), {
  ssr: false,
  fallback: <div></div>,
});

function LocationSidebar({ location }) {
  const { vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const [subscribeSuccess, setSubscribeSuccess] = useState(false);
  const [subscribeError, setSubscribeError] = useState(false);

  const [addLocationSubscriber] = useAddLocationSubscriberMutation();

  const onSubscribeSubmit = async (values) => {
    try {
      await addLocationSubscriber({
        id: location.id,
        email: values.email,
        frequency: values.frequency,
      }).unwrap().then(() => {
        setSubscribeSuccess(true);
      });
    } catch (err) {
      console.error('Failed to subscribe to Location: ', err);
      setSubscribeError(true);
    }
  };

  return (
    <div className={cn(sidebarStyles.Sidebar, styles.LocationSidebar)}>

      { location.pod &&
        <div className={sidebarStyles.Sidebar_item}>
          <div className={sidebarStyles.Sidebar_header}>
            <h3 className='u-phosphate u-mb0'>Subscribe to Location</h3>
          </div>
          <div className={sidebarStyles.Sidebar_padding}>
            <p>Get weekly updates on food {vehicleType} schedules, menus, and special events – delivered straight to your inbox!</p>

            { !subscribeSuccess && !subscribeError &&
              <LocationSubscribeForm onSubmit={onSubscribeSubmit} />
            }
            { subscribeSuccess && <p><strong>Thank you!</strong> You have been subscribed.</p> }
            { subscribeError && <p><strong>There was an error subscribing.</strong> Please refresh the page and try again.</p> }
          </div>
        </div>
      }

      { location && location.latitude && location.longitude &&
        <div className={sidebarStyles.Sidebar_item}>
          <LocationMap location={location} />
        </div>
      }

    </div>
  );
}

LocationSidebar.propTypes = {
  location: PropTypes.object.isRequired,
};

export default LocationSidebar;
